export const BASE_URL = "https://xlit-api.ai4bharat.org/";
export const BASE_URL_TL = "https://xlit-api.ai4bharat.org/tl/";
